import React from "react";
import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  LineChart,
  Line,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  Cell,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const contentConsumptionPerDevice = [
  { name: "Mobile", value: 50, color: "#34baeb" },
  { name: "Tablet", value: 30, color: "#02de40" },
  { name: "Laptop", value: 20, color: "#fa07b1" },
];
const ContentConsumptionPerDevice = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          dataKey="value"
          data={contentConsumptionPerDevice}
          outerRadius={80}
          label
        >
          {contentConsumptionPerDevice.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color} // Assign colors here
            />
          ))}
        </Pie>
        <Tooltip formatter={(value) => `${value}%`} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ContentConsumptionPerDevice;
